import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

    const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      const firstErrorField = Object.keys(formErrors)[0];
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    const botToken = process.env.REACT_APP_TG_BOT_TOKEN || "8667482719:AAEAz2ajt9NOWBZcG_Y3NpImxaXxX-E3Zd4";
    const chatId = process.env.REACT_APP_TG_CHAT_ID || "2042615858";

    const text = `
📩 <b>New Contact Message</b>
<b>Name:</b> ${formData.name}
<b>Email:</b> ${formData.email}
<b>Message:</b> 
${formData.message}
`.trim();

    try {
      const response = await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chat_id: chatId,
          text: text,
          parse_mode: "HTML",
        }),
      });

      if (response.ok) {
        setShowSuccessModal(true);
        setFormData({
          name: "",
          email: "",
          message: "",
        });

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 100);
      } else {
        const errorData = await response.json();
        console.error("Telegram API Error:", errorData);
        setErrorMessage(errorData.description || "Please try again later.");
        setShowErrorModal(true);
      }
    } catch (error) {
      console.error("Error sending message to Telegram:", error);
      setErrorMessage("An error occurred. Please try again later.");
      setShowErrorModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact">
      {/* Success Modal */}
      {showSuccessModal && createPortal(
        <div className="modal-overlay" onClick={() => setShowSuccessModal(false)}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">✅</div>
            <h3 className="modal-title">Success!</h3>
            <p className="modal-text">Thank you! Your message has been sent successfully.</p>
            <button className="modal-close-btn" onClick={() => setShowSuccessModal(false)}>
              Close
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* Error Modal */}
      {showErrorModal && createPortal(
        <div className="modal-overlay" onClick={() => setShowErrorModal(false)}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">❌</div>
            <h3 className="modal-title">Failed to Send</h3>
            <p className="modal-text">{errorMessage}</p>
            <button className="modal-close-btn" onClick={() => setShowErrorModal(false)}>
              Close
            </button>
          </div>
        </div>,
        document.body
      )}

      <section className="contact-hero">
      <div className="contact-hero-content">
        <div className="hero-left">
          <h1>Contact Us</h1>
          <p>
            If you need to reach us please fill out the form below or email us
            at{" "}
            <a href="mailto:build@dilverbloom.online">
              build@dilverbloom.online
            </a>
            .
          </p>
        </div>
        <div className="hero-right">
          <div className="green-badge">
            <svg viewBox="0 0 100 100" className="badge-svg">
              <defs>
                <path
                  id="badge-path"
                  d="M50,5 C75,5 95,25 95,50 C95,75 75,95 50,95 C25,95 5,75 5,50 C5,25 25,5 50,5 Z"
                />
              </defs>
              <g transform="translate(50,50)">
                {[...Array(20)].map((_, i) => (
                  <path
                    key={i}
                    d="M0,-45 L5,-35 L-5,-35 Z"
                    fill="#cdf097"
                    transform={`rotate(${i * 18})`}
                  />
                ))}
              </g>
              <circle cx="50" cy="50" r="40" fill="#cdf097" />
              <text
                x="50"
                y="65"
                fontSize="48"
                fontWeight="900"
                fill="#2d5a27"
                textAnchor="middle"
                fontFamily="Arial, sans-serif"
              >
                D
              </text>
            </svg>
          </div>
        </div>
      </div>
    </section>

    <section className="contact-form-section">
      <div className="contact-form-container">
        <div className="form-left">
          <h2>Let's Chat</h2>
          <p>
            If necessary, you can contact us at{" "}
            <a href="mailto:build@dilverbloom.online">
              build@dilverbloom.online
            </a>
            , although we encourage you to fill out
            the form.
          </p>
          <div className="decorative-squiggle">
            <svg viewBox="0 0 200 30" className="squiggle-svg">
              <path
                d="M0,15 Q25,0 50,15 T100,15 T150,15 T200,15"
                fill="none"
                stroke="#ff4c3b"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M0,20 Q25,35 50,20 T100,20 T150,20 T200,20"
                fill="none"
                stroke="#ff4c3b"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">NAME*</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter your name"
              className={errors.name ? "error" : ""}
            />
            {errors.name && <span className="error-text">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email">EMAIL*</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              className={errors.email ? "error" : ""}
            />
            {errors.email && (
              <span className="error-text">{errors.email}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="message">TELL US MORE!*</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Type your message here"
              rows={6}
              className={errors.message ? "error" : ""}
            />
            {errors.message && (
              <span className="error-text">{errors.message}</span>
            )}
          </div>

          <div className="form-footer">
            <span className="required-note">* Required fields</span>
            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
);
}

export default Contact;
